// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__OICxv","label":"styles_label__e72C9","icon":"styles_icon__bKikO"};